module.exports = __webpack_public_path__ + "static/media/clap.32883395.svg";